import { isLocalUrl } from '../utils';

export default function () {
  const widgetName = 'cardWidget';
  const widgetOpts = cardWidgetOpts;

  const wrapContainerClass = 'standard-cards-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    showDescription: false,
    moreButton: false,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`.${wrapContainerClass}`).remove();
      } else {
        createCustomCards(data.items);
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];

      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
            <div class="hover-content">
            </div>
          </div>`);

      if (isLocalUrl(URL)) {
        $cardItem.removeAttr('target');
      }

      if (!URL) {
        $cardItem.addClass('empty-card').removeAttr('href');
      }

      animateCard($cardItem, x);
    });
  }
}

function animateCard($cardItem, x) {
  $cardItem.css({
    opacity: 0,
    transform: 'translateX(-50px)',
  });

  const observer = new IntersectionObserver(
    (entries, obs) => handleIntersection(entries, obs, $cardItem, x),
    { threshold: 0.3 },
  );

  observer.observe($cardItem[0]);
}

function handleIntersection(entries, obs, $cardItem, x) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const duration = 800;
      const delay = x * 300;
      $cardItem.css({
        opacity: 1,
        transform: 'translateX(0)',
        transition: `all 0.8s ease-in-out ${x * 0.3}s`,
      });
      setTimeout(() => {
        $cardItem.css({ transition: 'none' });
      }, duration + delay);
      obs.unobserve(entry.target);
    }
  });
}
